import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { request } from "../lib/api";
import { LoadingState } from "../components/ui";

// Modules are built on their PD day's page now; old /modules/:id links land
// there instead.
export function ModuleRedirect() {
  const { id } = useParams<{ id: string }>();
  const [target, setTarget] = useState<string | null>(null);
  useEffect(() => {
    request<{ pd_day_id: string }>(`/api/admin/modules/${id}`)
      .then((module) => setTarget(`/pd-days/${module.pd_day_id}`))
      .catch(() => setTarget("/pd-days"));
  }, [id]);
  return target ? <Navigate to={target} replace /> : <LoadingState message="Opening PD day…" />;
}
